(function () {
    'use strict';

    angular
        .module('app.alerts')
        .controller('AlertDetailController', AlertDetailController);

    AlertDetailController.$inject = [
        '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'dataservice', 'attachmentService', '$window'
    ];

    function AlertDetailController($state, $stateParams,
        bsDialog, common, dataservice, attachmentService, $window) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;

        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;
        vm.submitForm = submitForm;
        vm.isNew = isNew;
        vm.openDatePicker = openDatePicker;
        vm.dpStatus = {
            displayFromOpen: false,
            displayToOpen: false
        }
        vm.fromDateChange = fromDateChange;
        vm.toDateChange = toDateChange;
        vm.attachmentsToRemove = [];
        vm.deleteAttachment = deleteAttachment;
        vm.departments = [];
        vm.templates = [];
        vm.templateChange = templateChange;

        activate();

        function activate() {
            initLookups();
            getItem();
        }

        function openDatePicker($event, isFrom) {
            if (isFrom) {
                vm.dpStatus.displayFromOpen = true;
            }
            else {
                vm.dpStatus.displayToOpen = true;
            }
        }

        function deleteAttachment(item, slide) {
            vm.attachmentsToRemove.push(slide.ID);
            $.each(item.Attachments, function (index, result) {
                if (result["ID"] == slide.ID) {
                    item.Attachments.splice(index, 1);
                }
            })
        }

        function fromDateChange() {
            vm.item.DisplayToDate = moment(vm.item.DisplayFromDate).add(vm.daysBetweenDates, 'days').toDate();
        }

        function toDateChange() {
            vm.daysBetweenDates = moment(vm.item.DisplayToDate).diff(vm.item.DisplayFromDate, 'days');
        }

        function submitForm(valid) {
            save();
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            if ($stateParams.fromDisplay) {
                $state.go("alerts.display")
            }
            else {
                $state.go("alerts.list");
            }
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Alert')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/Alerts/" + vm.item.ID).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function isNew() {
            var val = $stateParams.id; 
            return val === "0";
                
        }

        function initLookups() {
            dataservice.getItems("api/Departments/ActiveForUser").then(function (data) {
                vm.departments = data.data;
                vm.departments.push({ ID: -1, Description: "(all)" });
            }, function (error) { });

            dataservice.getItems("api/Alerts/GetTemplatesForUser").then(function (data) {
                vm.templates = data.data;
                
            }, function (error) { });
        }

        function getItem() {
            var val = $stateParams.id;
            if (val === '0') {
                vm.item = {};
                vm.item.DisplayFromDate = vm.item.DisplayFromTime = common.getMainState("mainDate");
                vm.item.DisplayToDate = vm.item.DisplayToTime = moment(common.getMainState("mainDate")).add(1, 'day').startOf('day').toDate();
                vm.item.Attachments = [];
                vm.daysBetweenDates = 1;
                vm.item.DepartmentId = parseInt($window.localStorage.getItem("SevenPointAlertDepartmentId")) || -1;
                common.setAuditInfo(vm.item);
                return vm.item;
            }

            return dataservice.getItem("api/Alerts/" + val)
                .then(function (data) {
                    if (data) {
                        vm.item = data.data;
                        common.convertUtcKeysToLocal(vm.item);
                        
                        vm.item.DisplayFromDate = vm.item.DisplayFromTime = vm.item.DisplayFromUtc;
                        
                        vm.item.DisplayToDate = vm.item.DisplayToTime = vm.item.DisplayToUtc;
                        common.setAuditInfo(vm.item);
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }


        function save() {
            var fromLocal = common.buildDateTime(vm.item.DisplayFromDate, vm.item.DisplayFromTime);
            var toLocal = common.buildDateTime(vm.item.DisplayToDate, vm.item.DisplayToTime);
            if (toLocal < fromLocal) {
                logger.error("Display To must be after Display From")
                return;
            }

            vm.item.DisplayFromUtc = moment(fromLocal).toISOString();
            vm.item.DisplayToUtc = moment(toLocal).toISOString();
            $window.localStorage.setItem("SevenPointAlertDepartmentId", vm.item.DepartmentId);
            var toSave = {
                CreatedById: vm.item.CreatedById,
                DepartmentId: vm.item.DepartmentId,
                Description: vm.item.Description,
                DisplayFromUtc: vm.item.DisplayFromUtc,
                DisplayToUtc: vm.item.DisplayToUtc,
                ID: vm.item.ID
            }
            vm.isSaving = true;
            dataservice.saveItem('api/Alerts', toSave).then(function (saveResult) {
                attachmentService.remove(vm.attachmentsToRemove);
                
                attachmentService.upload("Alert", saveResult.data.ID).then(function (attachmentResponse) {
                    vm.isSaving = false;
                    common.notifier.notify(common.config.events.refreshCounts);
                    backToList();
                }, function (error) { });
                
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }

        function templateChange() {
            if (vm.selectedTemplate) {
                for (var i = 0; i < vm.templates.length; i++) {
                    var t = vm.templates[i];
                    if (vm.selectedTemplate === t.UId) {
                        vm.item.Description = t.Description;
                        vm.item.DepartmentId = t.DepartmentId;
                        break;
                    }
                }
            }
        }

    }
})();
